import React, { Component } from 'react';
// hoc
import { withRouter } from 'react-router-dom';
// components
import Form from '../../../components/Form/Form';
import Button from '../../../components/Button/Button';
// styles
import styles from './CheckInInvitation.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const modals = {
  daily: {
    title: 'Daily check-in',
    route: 'daily-check-in',
  },
  weekly: {
    title: 'Weekly check-in',
    route: 'weekly-check-in',
  },
  monthly: {
    title: 'Monthly check-in',
    route: 'monthly-check-in',
  },
};

class CheckInInvitation extends Component {
  handleSubmit = () => {
    const {
      history,
      closeModal,
      modalData: { type },
    } = this.props;
    history.push(modals[type].route);
    closeModal();
  };

  render() {
    const {
      closeModal,
      modalData: { type },
    } = this.props;
    const title = modals[type].title;
    return (
      <Form className={cx('wrapper')}>
        <h2 className={cx('title')}>{title}</h2>
        <p className={cx('question')}>Would you like to take this survey?</p>
        <div className={cx('button-section')}>
          <Button plain onClick={closeModal}>
            Cancel
          </Button>
          <Button primary onClick={this.handleSubmit} type="submit">
            Continue
          </Button>
        </div>
      </Form>
    );
  }
}

export default withRouter(CheckInInvitation);



// WEBPACK FOOTER //
// ./src/containers/Module/components/CheckInInvitation.jsx